import React from 'react';
import { IonGrid, IonRow, IonCol, IonList, IonItem, IonLabel, IonButton } from '@ionic/react';

// Components
import { AmountComponent } from '../../components';

// Helpers
import { formatNumber } from '../../helpers';
import { APP_CONFIG } from '../../constants';

export const DetailComponent = ({
    pageConfig,
    transactionNumber,
    subscriber,
    benefit,
    amount,
    transactionStatus,
    setShowModal,
    inputs,
    validation,
    handleConfirm,
    handleCancel,
    handleInputChange,
    enabledEditAmount,
    discountPreview,
    hasCalculableDiscount,
    showActions = true
}) => {

    return (
        <form onSubmit={handleConfirm} noValidate>
            <IonGrid>
                <IonRow className="detail-grid-rows-2">
                    <IonCol>
                        <IonList className="personal-data">
                            <IonItem>
                                <IonLabel>
                                    <h3>
                                        NOMBRE COMPLETO
                                    </h3>
                                    <p>
                                        {subscriber?.name && subscriber?.name !== undefined ? subscriber?.name : APP_CONFIG.PAGES.DETAIL.messages.info?.name}
                                    </p>
                                </IonLabel>
                                <p className={`card state--${subscriber?.program?.id}`}>{subscriber?.program?.description}</p>
                            </IonItem>
                            <IonItem>
                                <IonLabel>
                                    <h3>
                                        DNI
                                    </h3>
                                    <p>
                                        {formatNumber(subscriber?.dni)}
                                    </p>
                                </IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonLabel>
                                    {
                                        benefit &&
                                        <>
                                            <h3>
                                                BENEFICIO
                                            </h3>
                                            <p>
                                                {`${benefit?.type} ${benefit?.title}`}
                                            </p>
                                        </>
                                    }
                                </IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonLabel>
                                    {
                                        benefit &&
                                        <>
                                            <h3>
                                                ID TRANSACCION
                                            </h3>
                                            <p>
                                                {transactionNumber}
                                            </p>
                                        </>
                                    }
                                </IonLabel>
                            </IonItem>
                            {benefit && hasCalculableDiscount &&
                                <IonItem className="discount-preview-item">
                                    <IonGrid className="discount-preview-grid">
                                        <IonRow>
                                            <IonCol>
                                                <h3>DESCUENTO APLICADO</h3>
                                                {discountPreview
                                                    ? <p>${formatNumber(discountPreview.saved)}</p>
                                                    : <p className="discount-hint">Aquí verás el descuento total aplicado</p>
                                                }
                                            </IonCol>
                                            <IonCol>
                                                <h3>IMPORTE CON DESCUENTO</h3>
                                                {discountPreview
                                                    ? <p>${formatNumber(discountPreview.withDiscount)}</p>
                                                    : <p className="discount-hint">Aquí verás el importe final con el descuento aplicado</p>
                                                }
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </IonItem>
                            }
                                {enabledEditAmount() &&

                                    <AmountComponent
                                        amount={amount}
                                        handleInputChange={handleInputChange}
                                        inputs={inputs}
                                        validation={validation}
                                        pageConfig={pageConfig}
                                        className="amount-component"
                                    />
                                }
                           
                                {!enabledEditAmount() &&
                                    <IonItem>
                                        <IonLabel>
                                            <>
                                                <h3>
                                                    IMPORTE SIN DESCUENTO
                                                </h3>
                                                <p>
                                                    {`$${formatNumber(amount) || 0}`}
                                                </p>
                                            </>
                                        </IonLabel>
                                    </IonItem>
                                }

                            
                        </IonList>
                    </IonCol>
                    <IonCol className="dispFlex-justEvenly">
                        {
                            showActions && enabledEditAmount() &&
                            <>
                            
                                <IonButton
                                    type="button"
                                    shape="round"
                                    size="undefined"
                                    color="danger"
                                    onClick={handleCancel}
                                >
                                    CANCELAR
                                </IonButton>
                                <IonButton
                                    type="submit"
                                    shape="round"
                                    size="undefined"
                                    disabled={!validation?.formComplete || !validation?.formValid}
                                >
                                    CONFIRMAR
                                </IonButton>
                            </>
                        }


                    </IonCol>
                </IonRow>
            </IonGrid>
        </form>
    )
}
